export var sweepColors = {
    blue: {
        100: '#DBEFFF',
        300: '#8FCCFF',
        500: '#1198FF',
        600: '#0077D2',
    },
    blush: {
        100: '#FFE9E0',
        300: '#FFB09D',
        500: '#FF572E',
        600: '#E22D00',
    },
    gum: {
        100: '#FEDFF9',
        300: '#F8BCF2',
        'S-500': '#FF56EE',
        500: '#F371E6',
    },
    lemon: {
        100: '#FFF4BF',
        300: '#FFEE94',
        500: '#FCE624',
    },
    lilac: {
        100: '#EBDEFF',
        300: '#C7ADFF',
        500: '#9462FF',
    },
    mint: {
        100: '#DFF8D5',
        300: '#83EC5D',
        500: '#59CE2F',
        700: '#2EB67D',
    },
    seafoam: {
        100: '#DEFBFF',
        300: '#C6EAEF',
        'S-500': '#ACE6F9',
        500: '#79D2E0',
    },
    sky: {
        100: '#E1EBFF',
        300: '#A5BEFF',
        500: '#577EE4',
    },
    storm: {
        50: '#F4F6FF',
        70: '#EDF0FE',
        200: '#D9E1FD',
        300: '#B2C1F8',
        400: '#7384C0',
    },
    sun: {
        100: '#FFF0D9',
        300: '#FFD28D',
        500: '#FF9900',
    },
};
